import { render, staticRenderFns } from "./ObratyDilnyDlePracovnika.vue?vue&type=template&id=5f99e688&"
import script from "./ObratyDilnyDlePracovnika.vue?vue&type=script&lang=ts&"
export * from "./ObratyDilnyDlePracovnika.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports